import { DestroyRef, Injectable, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, map, skip, startWith } from "rxjs/operators";

import { UtilsService } from "~/core/helpers/utils";

/**
 * Recarrega a página quando a viewport cruza o breakpoint desktop/mobile.
 *
 * O layout é decidido por `UtilsService.isDesktop()`, lido uma única vez na
 * construção de cada componente. Redimensionar a janela (ou ligar/desligar o
 * device toolbar do DevTools) não troca a tela: ela continua na versão anterior
 * — o sintoma de "a tela se mantém grande".
 *
 * ponytail: reload em vez de tornar reativas as ~240 chamadas de isDesktop()
 * espalhadas pelo app. Se um dia o layout todo virar signal, este serviço sai
 * inteiro.
 *
 * Reload descarta formulário não salvo. Aceito: só dispara ao cruzar o
 * breakpoint, algo que não acontece em uso normal de desktop nem de celular.
 */
@Injectable({ providedIn: "root" })
export class ViewportSwitchService {
  private readonly destroyRef = inject(DestroyRef);

  watch(): void {
    fromEvent(window, "resize")
      .pipe(
        debounceTime(250),
        map(() => UtilsService.isDesktop()),
        // Semeia com o estado atual para que o primeiro resize dentro da mesma
        // faixa (ex.: 1200px -> 1400px) não seja tratado como troca de layout.
        startWith(UtilsService.isDesktop()),
        distinctUntilChanged(),
        skip(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.reload());
  }

  /** Seam de teste: jsdom não permite substituir `window.location`. */
  protected reload(): void {
    window.location.reload();
  }
}
